import { z } from "zod";

export const ADMIN_STATS_DAYS = [7, 30, 90, 365] as const;
export type AdminStatsDays = (typeof ADMIN_STATS_DAYS)[number];

export const ADMIN_LIST_SORTS = ["recent", "wishes", "reserved", "clicks"] as const;
export type AdminListSort = (typeof ADMIN_LIST_SORTS)[number];

/**
 * Who an outside call went to, as recorded in `usage_events`. `queue` and `http` are not
 * vendors: they count failures the app swallows (an enqueue) or hides (a 500).
 */
export const USAGE_PROVIDERS = [
  "openai",
  "typesafe",
  "scrapingbee",
  "serper",
  "mail",
  "queue",
  "http",
] as const;
export type UsageProvider = (typeof USAGE_PROVIDERS)[number];

/** Rows in the admin's list table: a top-N, not a feed, so there is no cursor. */
export const ADMIN_LISTS_LIMIT = 100;

export const adminStatsQuerySchema = z.object({
  // Query strings arrive as strings, and a period is one of a few buttons, not free input.
  days: z.coerce.number().pipe(z.literal(ADMIN_STATS_DAYS)).default(30),
});

export const adminListsQuerySchema = z.object({
  sort: z.enum(ADMIN_LIST_SORTS).default("recent"),
});

export type AdminStatsQuery = z.input<typeof adminStatsQuerySchema>;
export type AdminListsQuery = z.input<typeof adminListsQuerySchema>;

export const ADMIN_PRODUCT_SORTS = ["recent", "wishes", "clicks"] as const;
export type AdminProductSort = (typeof ADMIN_PRODUCT_SORTS)[number];

export const ADMIN_PRODUCT_FILTERS = ["all", "no-price", "no-image"] as const;
export type AdminProductFilter = (typeof ADMIN_PRODUCT_FILTERS)[number];

/** Rows in the admin's product tables: a window to look through, not an export. */
export const ADMIN_PRODUCTS_LIMIT = 100;

export const adminProductsQuerySchema = z.object({
  /** A shop as products name it (`fnac.com`): its page in the admin. */
  host: z
    .string()
    .regex(/^[a-z0-9.-]+$/)
    .max(253)
    .optional(),
  sort: z.enum(ADMIN_PRODUCT_SORTS).default("recent"),
  filter: z.enum(ADMIN_PRODUCT_FILTERS).default("all"),
});

export type AdminProductsQuery = z.input<typeof adminProductsQuerySchema>;
